<div class="chart-container">
  <div class="chart-wrapper">
    <canvas #chartCanvas></canvas>
  </div>
  <div class="chart-summary" *ngIf="registrants && registrants.length > 0">
    <p class="total-count">Total Registrants: <strong>{{ registrants.length }}</strong></p>
  </div>
  <div class="no-data" *ngIf="!registrants || registrants.length === 0">
    <p>No registrants data available</p>
  </div>
</div>
